import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { StateProvinceResponse } from '../models/responses';

@Injectable()
export class StateProvinceService {

  constructor(public httpClient: HttpClient) { }

  getStateProvinceDropdown(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/StateProvince/Dropdown`;
    return this.httpClient.get<StateProvinceResponse[]>(url);
  }
  getStateProvinceDropdownAllCountries(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/StateProvince/Dropdown/AllCountries`;
    return this.httpClient.get<StateProvinceResponse[]>(url);
  }
  getFuelTaxList(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/StateProvince/FuelTax/List`;
    return this.httpClient.get<any[]>(url);
  }
  getStateBorderList(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/StateProvince/StateBorder/List`;
    return this.httpClient.get<any[]>(url);
  }

  getCountryDropdown(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/StateProvince/CountryDropdown`;
    return this.httpClient.get<any[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/state-province/state-province.service.ts